import { render, staticRenderFns } from "./memberIntroList.vue?vue&type=template&id=6a35be58&class=full-height"
import script from "./memberIntroList.vue?vue&type=script&lang=js"
export * from "./memberIntroList.vue?vue&type=script&lang=js"
import style0 from "./memberIntroList.vue?vue&type=style&index=0&id=6a35be58&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a35be58')) {
      api.createRecord('6a35be58', component.options)
    } else {
      api.reload('6a35be58', component.options)
    }
    module.hot.accept("./memberIntroList.vue?vue&type=template&id=6a35be58&class=full-height", function () {
      api.rerender('6a35be58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/member/components/memberIntroList.vue"
export default component.exports